import React from "react";
import NotFound from "../pages/NotFound";

const ProtectedRoute = ({ children }) => {
  const adminId = localStorage.getItem("adminId");

  // If adminId missing → show 404 page
  if (!adminId) {
    return <NotFound />;
  }

  return children;
};

export default ProtectedRoute;
